import { Box, styled } from "@mui/material";
import { colors, transitions } from "../../styles/theme";
import { convertToBreakpoints } from "../../utils/fuilds";
import { deviceStyles } from "../../hooks/useDeviceStyles";

const COLOR_YELLOW = '236, 187, 66';
const COLOR_BLUE = '131, 219, 240';
const COLOR_RED = '231, 51, 96';

export const Container = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  alignItems: 'center',
  width: "100%",
}));

export const samePadding = deviceStyles({
  mobile: {
    paddingTop: "5px"
  }
}, [
  { paddingTop: "5px" },
  { paddingTop: "5px" },
  { paddingTop: "15px" },
  { paddingTop: "25px" },
]);

export const IconLightCommon = styled(Box)(({ theme }) => ({
  display: 'inline-block',
  cursor: 'pointer',
  // ...deviceStyles({
  //   mobile: {
  //     marginBottom: "5px"
  //   }
  // }, [
  //   { marginBottom: "5px" },
  //   { marginBottom: "5px" },
  //   { marginBottom: "15px" },
  //   { marginBottom: "25px" },
  // ]),
  // ...convertToBreakpoints(theme, {
    // xs: { margin: '0 5px 5px 5px' },
    // md: { margin: '0 14px 10px 14px' },
    // xxxl: { margin: '0 18px 10px 18px' },
  // }),
  transition: transitions.join('color'),
  lineHeight: 1,
}));

export const IconLedCommon = styled(Box)(({ theme }) => ({
  position: 'relative',
  // ...convertToBreakpoints(theme, {
    // xs: { width: '30px'},
    // md: { width: '40px'},
    // xxxl: { width: '60px'}
  // }),

  ...deviceStyles({ mobile: {
    width: '12px',
    height: '12px',
  }}, [
    { width: '14px', height: '14px' },
    { width: '20px', height: '20px' },
    { width: '30px', height: '30px' }
  ]),

  textAlign: 'center',
  zIndex: 3,
  lineHeight: 1,
  display: 'inline-block',
  cursor: 'pointer',
  // '&.active': {
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '50%',
      top: '50%',
      zIndex: 2,
      transform: 'translateX(-50%) translateY(-50%)',
      transition: transitions.join(['width', 'height']),
      width: '0px',
      height: '0px',
      pointerEvents: 'none',
      filter: 'blur(2px)',
    },
  // },
  svg: {
    width: '100%',
    height: '100%',
    stroke: colors.text.v3,
    fill: colors.text.v3,
    transition: transitions.join(['opacity']),
    opacity: 1,
  },
  '&.active': {
    '&::before': {
      width: '30px',
      height: '30px',
      [theme.breakpoints.up('md')]: {
        width: '50px',
        height: '50px',
      },
      [theme.breakpoints.up('lg')]: {
        width: '80px',
        height: '80px',
      },
      [theme.breakpoints.up('xl')]: {
        width: '120px',
        height: '120px',
      },
    }
  },
  '&:not(.active)': {
    svg: {
      opacity: .4,
    }
  },
}));

export const IconLedWithGradientOrange = styled(IconLedCommon)(() => ({
  svg: {
    // fill: '#FAFFA0',
    // stroke: '#FAFFA0',
    fill: `rgba(${COLOR_YELLOW}, 1)`,
    stroke: `rgba(${COLOR_YELLOW}, 1)`,
  },
  '&.active': {
    // svg: { stroke: '#FAFFA0', },
    '&::before': {
      content: '""',
      background: `radial-gradient(
          circle closest-side,
          rgba(${COLOR_YELLOW}, 0.55) 0%,
          rgba(${COLOR_YELLOW}, 0.35) 45%,
          rgba(0,0,0,0) 75%
        )`,
    },
  }
}));

export const IconLedWithGradientBlue = styled(IconLedCommon)(() => ({
  svg: {
    // fill: '#64C1FF',
    // stroke: '#64C1FF',
    fill: `rgba(${COLOR_BLUE}, 1)`,
    stroke: `rgba(${COLOR_BLUE}, 1)`,
  },
  '&.active': {
    // svg: { stroke: '#64C1FF', },
    '&::before': {
      content: '""',
      background: `radial-gradient(
          circle closest-side,
          rgba(${COLOR_BLUE}, 0.55) 0%,
          rgba(${COLOR_BLUE}, 0.35) 45%,
          rgba(0,0,0,0) 75%
        )`,
    }
  }
}));

export const IconLedWithGradientRed = styled(IconLedCommon)(() => ({
  svg: {
    // fill: '#FF79A7',
    // stroke: '#FF79A7',
    fill: `rgba(${COLOR_RED}, 1)`,
    stroke: `rgba(${COLOR_RED}, 1)`,
  },
  '&.active': {
    // svg: { stroke: '#FF79A7', },
    '&::before': {
      content: '""',
      background: `radial-gradient(
          circle closest-side,
          rgba(${COLOR_RED}, .55) 0%,
          rgba(${COLOR_RED}, .35) 45%,
          rgba(0,0,0,0) 75%
        )`,
    }
  }
}));
